import React from 'react';

import { SettingsPanelContent } from './settings-panel-content';
import { SettingsPanelContext } from './settings-panel-context';
import { SettingsPanelTrigger } from './settings-panel-trigger';
import { useSettingsPanel, UseSettingsPanelProps } from './use-settings-panel';

type Props = {
  children?: React.ReactNode;
  content: React.ReactNode;
  onToggle: (open: boolean) => void;
} & UseSettingsPanelProps;

/**
 * Displays a tooltip when hovering the children prop. Make sure the children prop exposes a ref of
 * the DOM element that should trig the tooltip.
 */
const SettingsPanel = (props: Props) => {
  const tooltip = useSettingsPanel(props);

  React.useEffect(() => {
    props.onToggle(tooltip.open);
  }, [props, tooltip.open]);

  return (
    <SettingsPanelContext.Provider value={tooltip}>
      <SettingsPanelContent>{props.content}</SettingsPanelContent>
      <SettingsPanelTrigger>{props.children}</SettingsPanelTrigger>
    </SettingsPanelContext.Provider>
  );
};

export { SettingsPanel };
